module.exports = __webpack_public_path__ + "media/images/favicon-efa7f37785a514f290550e2ee1ed53d8.ico";